<template>
    <div class="pay_bgView">
        <pageHeader :showIndex="1" ref="pageHead"></pageHeader>
        <div class="pay_order">
            <div class="pay_order_info">
                <h1>订单支付</h1>
                <div class="pay_order_info_item">
                    <div class="order_number">订单编号:{{orderInfo.orderNum}}</div>
                    <div class="order_info_list clearfix">
                    <div class="order_info_lists_image fl">
                        <div v-if="orderInfo.coursePigImg == null || orderInfo.coursePigImg == 'null'">
                            <img src="../../assets/images/xybb.png" alt="">
                        </div>
                        <div v-else>
                            <img id="leftImage" :src="'http://image.xueyoubangbang.com/'+orderInfo.coursePigImg" alt="">
                        </div>
                    </div>
                    <div class="fl box">
                        <span class="order_info_list_title">
                        <div class="">{{orderInfo.courseName}}</div>
                        <div class=""><!-- 有效期：无 --></div>
                        </span>
                        <span class="order_info_list_oldprice">原价：{{orderInfo.realPrice}}元</span>
                        <span class="order_info_list_discount">优惠方式：无</span>
                        <span class="order_info_list_realprice color-red">￥{{orderInfo.realPrice}}</span> 
                    </div>
                    </div>
                </div>
            </div>
            <div class="pay_method clearfix">
                <h1>支付方式</h1>
                <div class="card">
                    
                    <a class="weixin" :class="{active:isWeipay}" href="javascript:void(0)" @click="selectPayType(1)">
                    <img class="payImage" src="../../assets/images/weipay.png">
                    <div class="pay-bg"></div>
                    </a>
                </div>
                <span class="warning"> 
                    <i class="iconfont color-red">&#xe63c;</i>请在24小时内完成支付,如未完成此订单将自动关闭,课程需重新购买!
                </span> 
            </div>

            <div class="pay_topay clearfix">
                <div class="fr">
                    <div class="payable">应付金额:<b class="color-red">￥{{orderInfo.realPrice}}</b></div>
                    <a class="pay-btn" :href="aliypayUrl" target="_blank" @click="toPayWithOrderNumber" v-if="isAlipay == true">支付</a>
                    <!-- {name:'wxPay',params:{orderId:routeOrderId}} -->
                    <a class="pay-btn" @click="toPayWithOrderNumber" href="javascript:;" v-if="isWeipay == true">支付</a>
                </div>
            </div>

            <!-- 支付宝弹出视图 -->
            <div class="order-layer-bg" v-if="isShow">
                <div class="order-layer">
                    <div class="head">订单支付</div>
                    <div class="con">
                    <div class="con-txt">
                        <strong>请在新打开的页面完成支付</strong>
                        <p>支付完成前请不要关闭窗口</p>
                        <p>支付完成后，将返回你购买的课程页面</p>
                        <p>未支付成功，请在支付页面继续完成支付</p>
                    </div>
                    </div>
                    <div class="footer">
                    <a class="pay-finish" href="javascript:void(0);" @click="paySuccessedToCourseDetail">支付完成</a>
                    <a class="replace" href="javascript:void(0);" @click="isShow = false">更换支付方式</a>
                    </div>
                </div>
            </div>

            <!-- 微信支付弹出框 -->
            <div class="layer-bg" v-show="wxPayViewShow"></div>
                <div class="wx-layer" v-show="wxPayViewShow">
                <div><i class="iconfont fr" @click="closeWxPay">&#xe635;</i></div>
                <div class="layer-content">
                    <p>{{wxMsg}}</p>
                    <div class="wx-pay">
                         <canvas id="canvas" :cls="qrCls" v-show="qrShow"></canvas>
                    </div>
                </div>
            </div>
        </div>
        <pageFooter></pageFooter>
    </div>
</template>
<script>
import pageHeader from '../header/header'
import pageFooter from "../footer/pageFooter"

import QRCode from 'qrcode'
export default {
    name: 'app',
    components: {
        pageHeader,
        pageFooter
    },
    data() {
        return {
        orderInfo:{},
        payType: 0,
        isAlipay:false,
        isWeipay:true,
        aliypayUrl:'',
        isErrorMsg:'',
        isShow:false,
        routeOrderId:'',
        wxPayViewShow:false,
        wxMsg:'请扫描二维码完成支付',
        qrText:'',
        qrCls:'qrcode',
        qrShow:false,
        timer:null,
        }
    },
    created () {
       
        this.routeOrderId = this.$route.params.orderId;
        this.getAlipayUrl(this.routeOrderId);
        this.payGetOrderInfoWithOrderId(this.$route.params.orderId)
    },
    mounted(){
      //this.useqrcode();
    },
    methods:{
        useqrcode(){
            var canvas = document.getElementById('canvas')
    
            QRCode.toCanvas(canvas, this.qrText, function (error) {
            if (error) console.error(error)
                console.log('success!');
            })
        },
        getAlipayUrl(orderId){
            this.aliypayUrl = this.baseUrl()+'/mobilePhone/paymentUrl/toMobileAlipay?orderId='+orderId+'&isWeb=1';
        },
         // 根据orderId 获取 订单详情
        payGetOrderInfoWithOrderId(orderId){
            let postData = {
                subOrderId: orderId,
                userId:localStorage.userId,
                token: localStorage.token
            };
            
            this.$http.post(this.baseUrl()+'/mobile/payOrder/findOrderDetail',
                    this.$qs.stringify(postData),
                    {headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((successResp) => {
                if(successResp.data.flag == 1){
                     this.orderInfo = successResp.data.data
                    
                }else{
                    this.isErrorMsg= successResp.data.msg
                }

            })
            // console.log('zezefamily',orderId)
            //this.requestData('/mobile/payOrder/findOrderDetail',{subOrderId:orderId},0)
        },

        //选择支付方式
        selectPayType(type){
            if(type == 0){
                this.isAlipay = true
                this.isWeipay = false
            }else {
                this.isAlipay = false
                this.isWeipay = true
            }
        },
        // 支付按钮被点击 去支付
        toPayWithOrderNumber: function() {
            // console.log(this.isAlipay,"0000")
            if(this.isAlipay == true){
                this.isShow = true
                console.log('支付宝支付')
                // this.href = 'http://112.126.80.53:8080/mobilePhone/paymentUrl/toMobileAlipay?orderId='+this.$route.params.orderId+'&isWeb=1'
            }else if(this.isWeipay == true){
                console.log('微信支付')
                this.isShow = false
                this.wxPayViewShow = true
                //请求数据
                this.startToWxPay()
            }
        },
        paySuccessedToCourseDetail()
        {
            this.isShow = false
            this.$router.go(-1)
        },
        startToWxPay(){
            this.$http.post(this.baseUrl()+'/pcWxPayOrder/toWxPayIndex/'+this.routeOrderId,
                '',
                {headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((successResp) => {
                if(successResp.data.flag == 1){
                    this.qrText = successResp.data.token
                    this.qrShow = true
                    this.useqrcode();
                    
                }else{
                    this.isErrorMsg= successResp.data.msg
                }

            })
        },
        closeWxPay(){
            this.wxPayViewShow = false
            clearInterval(this.timer);
        },
    }
}
</script>
<style scoped>
    .wx-layer{
        width: 360px;
        height: 400px;
        background: #fff;
        border-radius: 4px;
        position: fixed;
        top: 20%;
        left: 50%;
        margin-left: -180px;
        z-index: 201;
    }
    .layer-bg{
        width: 100%;
        height: 100%;
        background:rgba(0,0,0,0.5);
        position: fixed;
        left: 0;
        top: 0;
        z-index: 200;
    }
    .layer-content p{
        width: 100%;
        text-align: center;
        margin:2em 0;
    }
    .layer-content .wx-pay{
        width: 280px;
        height: 280px;
        margin: 0 auto;
        color: #dfdfdf;
        text-align: center;
    }
    #canvas{
        width: 262px;
        height: 262px;
        margin: 0 auto;
    }
    .errorMsg{
        width: 100%;
        background-color: #fff;
        font-size: 20px;
        text-align: center;
        min-height: 200px;
        line-height: 200px;
    }
    .order-layer-bg{
        /*display: none;*/
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
    }
    .order-layer{
        width: 565px;
        height: 254px;
        margin-left: -282px;
        background: #fff;
        border-radius: 2px;
        overflow: hidden;
        position: fixed;
        top: 30%;
        left: 50%;
    }
    .head{
        background: #eaeaea;
        padding: 17px 0;
        color: #333;
        text-align: center;
        font-weight: bold;
    }
    .con-txt{
        width: 100%;
        padding-top: 20px;
        text-align: center;
    }
    .con-txt strong{
        font-size: 20px;
        padding:10px 0;
        display: inline-block;
    }
    .con-txt p{
        line-height: 24px;
    }
    .footer{
        margin-top: 10px;
        text-align: center;
    }
    .footer a{
        display: inline-block;
    }
    .pay-finish{
        background: #00ced1;
        color: #fff;
        border-radius: 2px;
        padding: 7px 10px;
        margin-right: 60px;
    }
    .replace{
        color: #00ced1;
    }

    .pay_bgView {
        margin: 0 auto;
        width: 100%;
        background: #f7f7f7;	
    }
    .pay_order {
        margin: 0 auto 50px;
        width: 1200px;
        min-height: 60vh;
    }
    .pay_order_info h1{
        margin:20px 0px 20px;
        font-style: 20px;
    }
    .pay_order_info_item{
        padding: 0 20px 15px;
    }
    .pay_order_info_item .order_number {
        line-height: 66px;
    }
    .pay_order_info_item {
        background: white;
    }
    .pay_order_info_item .order_info_list .box{
        width: 80%;
        margin-top: 20px;
    }
    .pay_order_info_item .order_info_list .box>span[class^="order_info_list_"]{
        padding:0 10px;
        color: #999;
        vertical-align: middle;
        display: inline-block;
    }
    .pay_order_info_item .order_info_list .order_info_list_title{
        width: 25%;
        text-align: left;
    }
    .pay_order_info_item .order_info_list .box .order_info_list_title:first-child{
        color: #363d48;
        overflow: hidden;
    /*width: 100px;*/
    }
    .pay_order_info_item .order_info_list .order_info_list_oldprice{
        width: 22%;
    }
    .pay_order_info_item .order_info_list .order_info_list_discount{
        width: 22%;
    }
    .pay_order_info_item .order_info_list .order_info_list_realprice{
        width: 20%;
    }
    .order_info_list {
        margin: 20px;
    }
    .order_info_lists_image {
        width: 164px;
        height: 98px;
        vertical-align: middle;
        margin-right:30px;
        overflow: hidden;
    }
    .order_info_lists_image img{
        width:164px;
        height: 98px;

    }
    #leftImage {
        width: 100%;
        width: 164px;
        height: 98px;
    }
    .pay_method h1{
        margin:25px 0 25px 20px;
    }
    .pay_method .card{
        padding-bottom: 30px;
        border-bottom:1px solid #dfdfdf;
        margin-bottom: 7px;
    }
    .pay_method .card a{
        width: 96px;
        height: 35px;
        line-height: 57px;
        text-align: center;
        padding: 10px 18px;
        display: inline-block;
        border:1px solid #dfdfdf;
        position: relative;
        margin-right: 24px;
    }
    .pay_method .card a.weixin img{
        padding-top: 4px;
    }
    .pay_method .card a.active,
    .pay_method .card a:hover{
        background: #fff;
    }
    .pay_method .card a.active .pay-bg,
    .pay_method .card a:hover .pay-bg{
        display: block;
    }
    .pay_method .card a .pay-bg{
        width: 132px;
        height: 55px;
        display: none;
        border-color:#f7f7f7;
        background: url(../../assets/images/payBorderSelected.png) no-repeat;
        background-size: cover; 
        content: "\20";
        position: absolute;
        top: 0;
        left: 0;
    }
    .warning{
        display: inline-block;
    }
    .warning i{
        padding: 0 10px 0 20px;
    }
    .pay_topay{
        width: 100%;
    }
    .payable{
        color: #666;
        font-style: 20px;
        margin-bottom: 22px;
    }
    .payable b{
        font-weight: normal;
        margin-left: 16px;
    }
    .pay-btn{
        display: inline-block;
        background: #00ced1;
        color: #fff;
        padding: 10px 40px;
        border-radius: 2px;
        font-size: 20px;
    }
    .color-red{
        color: #ff6060 !important;
    }
</style>